import * as React from "react";

export const EditIcon: React.SFC = ({}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        fill="#747474"
        fillRule="nonzero"
        stroke="#747474"
        strokeWidth=".6"
        d="M16.872 11.332l-9.24 9.243a.488.488 0 0 1-.094.077l-.01.005v.001l-.01.005-.001.001-.01.005-.01.006h-.001l-.01.005h-.001l-.01.005h-.001l-.01.004h-.001l-.002.001-.01.004-.01.004H7.44l-.01.004h-.002l-.01.003h-.002l-.009.003-.003.001-4.758 1.266a.494.494 0 0 1-.63-.597l1.284-4.752.002-.004a.351.351 0 0 1 .009-.03l.001-.003.003-.007.001-.004.002-.003v-.001l.001-.003.002-.003.001-.004v-.001l.002-.002.001-.004.002-.004.006-.013.002-.004.001-.004.002-.002v-.001l.002-.004.002-.003.001-.003.002-.004.002-.003.002-.004.002-.003.002-.004.002-.003.002-.003.003-.004.002-.003.002-.003.002-.004.002-.003.002-.003.002-.003.003-.004v-.001l.002-.002.002-.003.003-.004.002-.003.003-.003.002-.003.001-.001.002-.002.002-.003.003-.003.002-.002v-.001l.003-.003.003-.003.002-.002v-.001l.003-.003.003-.003.002-.003.003-.003.003-.003.003-.003 9.153-9.157.13-.134v-.001l4.95-4.974a.49.49 0 0 1 .695 0l.022.024 3.48 3.453c.193.19.195.502.005.696l-.003.003h.001c-1.662 1.67-3.32 3.344-4.986 5.011h.001zm.644-3.433a.494.494 0 0 1-.005-.696c.19-.194.5-.197.693-.006l.7.696 1.911-1.92L18.01 3.19 16.1 5.11l1.17 1.16c.193.19.195.502.005.696a.488.488 0 0 1-.693.006l-1.176-1.166-2.003 2.012v-.001c-2.943 3.003-5.959 5.963-8.932 8.938l2.807 2.787 8.904-8.906.058-.064 1.972-1.982-.695-.69zM6.324 19.979l-2.296-2.28-.84 3.113 3.136-.834z"
      />
      <path
        fill="#747474"
        d="M15.058 5.677l.958-.863 2.951 2.916-.824 1.014z"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/entityView/EditIcon.tsx